import { createFileRoute } from "@tanstack/react-router";

import { TerminalShell } from "../components/terminal/terminal-shell";

export const Route = createFileRoute("/terminal")({
  component: TerminalPage,
});

/**
 * `/terminal` — the tabbed workspace shell. One workspace == one tab; the
 * active workspace's `PageManifest` renders through the Page Runtime below the
 * tab strip. See `components/terminal/terminal-shell.tsx`.
 */
function TerminalPage() {
  return <TerminalShell />;
}
